import {AsyncInlineError, inlineError} from '@s-ui/decorators'

import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {GenericAuthenticationrError} from '../Errors/GenericAuthenticationError.js'
import AuthenticationMappersFactory from '../Mappers/factory.js'
import AuthenticationRepository from './AuthenticationRepository.js'

export class HttpAuthenticationRepository extends AuthenticationRepository {
  #config
  #fetcher
  #fetchOrFail
  #genericError
  #sessionMapper
  #apiUrl

  constructor({config, fetcher, fetchOrFail, genericError, sessionMapper}) {
    super()
    this.#config = config
    this.#fetchOrFail = fetchOrFail
    this.#fetcher = fetcher
    this.#genericError = genericError
    this.#sessionMapper = sessionMapper
    this.#apiUrl = this.#config.get('API_URL')
  }

  static create({config}) {
    const fetchOrFail = FetcherFactory.fetchOrFail({config})
    const fetcher = FetcherFactory.httpFetcher({config})
    const genericError = GenericAuthenticationrError
    const sessionMapper = AuthenticationMappersFactory.httpResponseToSessionAuthenticationMapper({config})
    return new HttpAuthenticationRepository({config, fetcher, fetchOrFail, genericError, sessionMapper})
  }

  login({gigyaSignatureEntity, suppressVerificationEmail}) {
    const url = suppressVerificationEmail
      ? `${this.#apiUrl}/users/credentials?suppressVerificationEmail=true`
      : `${this.#apiUrl}/users/credentials`
    return this.#fetcher.post(url, gigyaSignatureEntity.toJSON()).then(response => {
      return this.#sessionMapper.map(response.data)
    })
  }

  @AsyncInlineError()
  async notifyResetPassword({UID}) {
    const {GENERIC} = this.#config.get('COMMON').ERRORS

    const [error] = await this.#fetchOrFail
      .withErrorsFactories({
        [GENERIC]: () => {
          return this.#genericError.create({
            message: 'Generic Authentication Error'
          })
        }
      })
      .put(`${this.#apiUrl}/users/${UID}/password/sync`)

    if (error) return Promise.reject(error)

    return Promise.resolve({})
  }

  @inlineError
  getAuthenticationToken({userEntity}) {
    const {userId, token} = userEntity?.toJSON() || {}
    return this.#fetcher.post(`${this.#apiUrl}/authentication`, {userId, token})
  }
}
